// extracted by mini-css-extract-plugin
export var quillEditor = "_q3-1";
export var variable = "_q3-0";